import helpers from './helpers'
import { constants } from '../utils/constants'

const consensusAbi = [
  {
    constant: true,
    inputs: [],
    name: 'getValidators',
    outputs: [{ name: '', type: 'address[]' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_someone', type: 'address' }],
    name: 'isValidator',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  }
]

export default class PoaConsensus {
  async init({ web3, netId, addresses }) {
    const consensusAddress = addresses.CONSENSUS_ADDRESS || addresses.POA_ADDRESS
    this.address = consensusAddress

    let abi = consensusAbi
    try {
      const remoteAbi = await helpers.getABI(constants.NETWORKS[netId].BRANCH, 'PoaNetworkConsensus')
      if (remoteAbi && remoteAbi.length) {
        abi = remoteAbi
      }
    } catch (e) {
      console.warn('Using local Consensus ABI', e.message)
    }

    this.instance = new web3.eth.Contract(abi, consensusAddress)
  }
  async getValidators() {
    const validators = await this.instance.methods.getValidators().call()
    return validators
  }
  async isValidator(address) {
    if (!address) {
      return false
    }
    if (this.instance.methods.isValidator) {
      return await this.instance.methods.isValidator(address).call()
    }
    const validators = await this.getValidators()
    return validators.some(validator => validator.toLowerCase() === address.toLowerCase())
  }
  async isMasterOfCeremonyRemoved() {
    if (this.instance.methods.isMasterOfCeremonyRemoved) {
      return await this.instance.methods.isMasterOfCeremonyRemoved().call()
    }
    return false
  }
}
